<mat-spinner active [color]="color" [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>
